module.exports = __webpack_public_path__ + "static/media/backgroundMobile.3e5fd0f9.png";